import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_CHILD_LOCATIONS, GET_PARENT_LOCATION } from "../../utils/queries";

export const getParentLocationThunk = createAsyncThunk(
  "getParentLocationSlice/getParentLocationThunk",
  async (
    { startsWith, status, locationType },
    { getState, rejectWithValue }
  ) => {
    const state = getState();
    const query = GET_PARENT_LOCATION;
    const accessToken = state.auth.token;
    try {
      const response = await fetch(process.env.REACT_APP_API_MASTER_DATA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query,
          variables: { startsWith, status, locationType },
        }),
      });
      const json = await response.json();
      if (json.errors) {
        return rejectWithValue({
          message: json.errors[0].message,
          locationType,
        });
      }
      return { data: json.data.getLocationByName, locationType };
    } catch (error) {
      return rejectWithValue({ message: error.message, locationType });
    }
  }
);

export const getChildLocationThunk = createAsyncThunk(
  "getChildLocationSlice/getChildLocationThunk",
  async ({ variables }, { getState, rejectWithValue }) => {
    const state = getState();
    const query = GET_CHILD_LOCATIONS;
    const accessToken = state.auth.token;
    try {
      const response = await fetch(process.env.REACT_APP_API_MASTER_DATA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query,
          variables:variables,
        }),
      });

      const json = await response.json();
      if (json.errors) {
        return rejectWithValue({ message: json.errors[0].message });
      }
      return { data: json.data.getAllChildrenLocationsWithParentId };
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);
